var React = require('react');

function Alignleft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.93 4.14h22.21M3.86 7.57H21M3.86 11h22.21M3.86 14.43H21M3.86 17.86h22.21"}));
}

Alignleft.defaultProps = {"viewBox":"0 0 30 22"};

module.exports = Alignleft;

Alignleft.default = Alignleft;
